import { render, staticRenderFns } from "./PointExpireMemberSummary.vue?vue&type=template&id=0f208945"
import script from "./PointExpireMemberSummary.vue?vue&type=script&lang=js"
export * from "./PointExpireMemberSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports